import { Content } from "@patternfly/react-core";
import { useTranslation } from "react-i18next";

export default NotFound;

function NotFound() {
  const { t } = useTranslation("not-found");
  return <Content component="p">{t("contents")}</Content>;
}
